import {Component, EventEmitter, input, Input, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  imports: [
    CommonModule,
    ButtonComponent,
  ]
})
export class EmptyStateComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() showButton = false;
  @Input() buttonText = '';
  @Input() imageSrc = '/assets/logo/empty-img.svg';
  buttonDisabled = input<boolean>(false);
  @Output() buttonClick = new EventEmitter<void>();

  onClick() {
    this.buttonClick.emit();
  }
}
